import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { bonusGameApi } from 'src/api/bonus-game';
import { CheckNextRewardsResponseObject } from 'src/api/Api';
import { ReactComponent as InviteFriendsIcon } from 'src/assets/icons/bonus-game/invite-friends.svg';
import { ReactComponent as LeaderboardIcon } from 'src/assets/icons/bonus-game/leaderboard.svg';
import { ReactComponent as QuestsIcon } from 'src/assets/icons/bonus-game/quests.svg';
import { MultiplierModal } from '../MultiplierModal';

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin: 20px 0;
`;

const ActionItem = styled.div`
  background-color: #1a222c;
  border-radius: 12px;
  padding: 8.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  max-width: 80px;
  height: 100%;
  max-height: 56px;
`;

const IconWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ActionText = styled.div`
  font-size: 12px;
  color: #ffffff;
  text-align: center;
`;

const ActionValue = styled.span`
  color: #b9f53a;
`;

const MultiplierValue = styled.span`
  color: #b9f53a;
  font-size: 16px;
`;

export const GameActions = () => {
  const navigate = useNavigate();
  const [rewardData, setRewardData] =
    useState<null | CheckNextRewardsResponseObject>(null);
  const [showMultiplierModal, setShowMultiplierModal] = useState(false);
  const [questCount, setQuestCount] = useState(0);

  useEffect(() => {
    const fetchRewardData = async () => {
      try {
        const nextReward = await bonusGameApi.checkNextReward();
        const questInfoRes = await bonusGameApi.getQuestsInfo({ filter: '' });
        setRewardData(nextReward);
        setQuestCount(questInfoRes.total);
      } catch (error) {
        console.error('Failed to fetch reward data:', error);
      }
    };
    fetchRewardData();
  }, []);

  return (
    <>
      <ActionsWrapper>
        <ActionItem onClick={() => navigate('/bonus-game/quests')}>
          <IconWrapper>
            <QuestsIcon />
          </IconWrapper>
          <ActionText>
            Quests <ActionValue>{questCount}</ActionValue>
          </ActionText>
        </ActionItem>

        <ActionItem onClick={() => navigate('/bonus-game/top-leaderboard')}>
          <IconWrapper>
            <LeaderboardIcon />
          </IconWrapper>
          <ActionText>Leaders</ActionText>
        </ActionItem>

        <ActionItem onClick={() => setShowMultiplierModal(true)}>
          <IconWrapper>
            <MultiplierValue>
              x{rewardData?.multiplicator ?? '1'}
            </MultiplierValue>
          </IconWrapper>
          <ActionText>Multiplier</ActionText>
        </ActionItem>

        <ActionItem onClick={() => navigate('/bonus-game/invite')}>
          <IconWrapper>
            <InviteFriendsIcon />
          </IconWrapper>
          <ActionText>Invite</ActionText>
        </ActionItem>
      </ActionsWrapper>

      {showMultiplierModal && (
        <MultiplierModal
          closeModal={() => setShowMultiplierModal(false)}
          multiplier={rewardData?.multiplicator ?? '1'}
        />
      )}
    </>
  );
};
